(function() {
  'use strict';

  angular
    .module('admin.campaigns.service', [])
    .factory('CampaignsService', CampaignsService);

  /** @ngInject */
  function CampaignsService($http, $q, API) {

    function listGeneral(start, limit, sort){
        var defered = $q.defer();

        $http.get(API.API_URL + 'admin/promo_campaigns/general?start=' + start + '&limit=' + limit + '&sort=' + sort)
          .success(defered.resolve);

        return defered.promise;
    }

    function listAffiliate(start, limit, sort){
      var defered = $q.defer();

      $http.get(API.API_URL + 'admin/promo_campaigns/affiliate?start=' + start + '&limit=' + limit + '&sort=' + sort)
        .success(defered.resolve);

      return defered.promise;
    }

    function get(id){
        var defered = $q.defer();

        $http.get(API.API_URL + 'admin/promo_campaigns/' + id)
          .success(defered.resolve);

        return defered.promise;
    }

    function save(model){
        var defered = $q.defer();

        $http.post(API.API_URL + 'admin/promo_campaigns', model)
          .success(defered.resolve);

        return defered.promise;
    }

    function update(id, model){
        var defered = $q.defer();

        $http.put(API.API_URL + 'admin/promo_campaigns/' + id, model)
          .success(defered.resolve);

        return defered.promise;
    }

    function remove(id){
        var defered = $q.defer();

        $http.delete(API.API_URL + 'admin/promo_campaigns/' + id)
          .success(defered.resolve)
          .error(defered.reject);

        return defered.promise;
    }

    function addPromoCampaignAffiliate(parentId, model){
      var defered = $q.defer();

      $http.post(API.API_URL + 'admin/promo_campaigns/' + parentId + '/affiliates', model)
        .success(defered.resolve);

      return defered.promise;
    }

    return{
       listGeneral: listGeneral,
       listAffiliate: listAffiliate,
       get: get,
       save: save,
       update: update,
       remove: remove,
       addPromoCampaignAffiliate: addPromoCampaignAffiliate,
    };

  }

})();
